import { Button, Modal } from "antd";
import React from "react";

function SetupCompleteModal(props) {
  function handleOk() {
    props.handleOk();
    props.handleCancel();
  }
  return (
    <Modal
      title="Complete setup"
      visible={props.visible}
      onOk={() => handleOk()}
      onCancel={props.handleCancel}
      footer={null}
      width={370}
    >
      <div className="mb-6">
        Once you complete the setup you can't delete or change the order of the
        organizational levels and plan levels.
      </div>
      <div className="flex justify-end">
        <Button className="mr-3 w-20" onClick={props.handleCancel}>
          No
        </Button>
        <Button className="w-20" type="primary" onClick={() => handleOk()}>
          Yes
        </Button>
      </div>
    </Modal>
  );
}

export default SetupCompleteModal;
